const list = `
iamgod
`
    .trim()
    .split('\n');

export default list;
